<template>
    <div
        v-if="packages.length || jumpUrl"
        class="detail-download-wrapper"
        @click.stop="downloadApp"
    >
        <div
            v-if="appDetail.join_community_info"
            class="download-btn go-community"
            :style="{
                backgroundColor: 'rgba(51,136,255,0.09)',
                width: '25vw',
            }"
            @click.stop="toTieba"
        >
            <div class="btn-text center" :style="{color: '#3388FF'}">
                {{ appDetail.join_community_info.join_community_txt }}
            </div>
        </div>
        <div
            class="download-btn"
            :style="{
                backgroundColor: $root.officialHighLightBtnColor,
                width: appDetail.join_community_info ? '63vw' : '91vw',
            }"
        >
            <div class="btn-text center">
                {{ btnText }}
            </div>
        </div>
    </div>
</template>

<script>
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import {getDeepValue} from '@/utils/utility';
import {generateToken} from '@/utils/tiebaUtility';
import {copy} from '@/utils/browser';
// pc游戏是否为免费游戏
const IS_FREE = {
    FREE: 1,
    NOT_FREE: 2,
    UNKNOWN: 3,
};
export default {
    props: {
        jumpUrl: {
            type: String,
            default: '',
        },
        packages: {
            type: Array,
            default: () => [],
        },
        lowPrice: {
            type: String,
            required: '',
        },
        officialJoined: {
            type: Boolean,
            default: false,
        },
        interBtnText: { // 干预按钮文案
            type: Object,
            default: () => ({}),
        },
        isFree: {
            type: Number,
            default: IS_FREE.UNKNOWN,
        },
        appDetail: {
            type: Object,
            required: true,
        },
    },
    computed: {
        /**
         * PC按钮文案逻辑
         * 文案整体分为两种：购买类、下载类。付费游戏购买，免费游戏下载
         *
         * 区分下载类还是购买类：
         *  下载类：isFree字段为IS_FREE.FREE
         *  购买类：isFree字段为IS_FREE.NOT_FREE
         *  另外假设isFree字段是第三种情况IS_FREE.UNKNOWN，需要根据lowPrice来判断，为空或者`免费`则认为是下载类，有具体价格为购买。
         *
         * 上述已经能够区分下载和购买
         *
         * 如果有云控文案
         *  下载类（downloadBtnText）：
         *      则取downloadBtnText
         * 购买类（buyBtnText）：
         *      则取buyBtnText
         *
         * 否则 将是下列逻辑
         *  isOfficial ? '官方' : '推荐'
         *  购买类 ? '购买' : '下载'
         *  购买类 ？ lowPrice : ''
         * 比如 isOfficial 购买类 98块 => 官方购买 ￥98
         */
        btnText() {
            // 官方判断逻辑
            if (!this.packages || !this.packages.length) {
                if (this.jumpUrl) {
                    return '进入游戏';
                }
                return '';
            }
            let isOfficial = false;
            const {OFFICIAL_FREE, OFFICIAL_PAY, NUKNOW} = this.$root.DOWNLOAD_ACTIONS;
            const officialList = [OFFICIAL_FREE, OFFICIAL_PAY];
            if (this.packages.length === 1
                && this.packages[0].action === NUKNOW
                && this.officialJoined) {
                isOfficial = true;
            }
            else {
                this.packages.forEach(item => {
                    if (officialList.includes(item.action)) {
                        isOfficial = true;
                    }
                });
            }

            // 是否为官方
            const downloadBtnText = getDeepValue(this.interBtnText, 'down_data');
            const buyBtnText = getDeepValue(this.interBtnText, 'buy_data');

            // 未知？
            const isUnknown = !Object.values(IS_FREE).includes(this.isFree) || this.isFree === IS_FREE.UNKNOWN;
            // 免费否
            const isFree = this.isFree === IS_FREE.FREE || isUnknown && (!this.lowPrice || this.lowPrice === '免费');

            // 云控逻辑
            if (isFree && downloadBtnText) {
                return downloadBtnText;
            }
            if (!isFree && buyBtnText) {
                return buyBtnText;
            }

            const textPrefix = isOfficial ? '官方' : '推荐'; // 官方文案前缀
            const textAction = isFree ? '推荐渠道' : '购买'; // 行动
            const textJoin = isFree ? textAction : textPrefix + textAction;
            const defaultPriceTag = !isFree && this.lowPrice !== '免费' ? ` ￥${this.lowPrice}` : ''; // 价格信息

            return `${textJoin}${defaultPriceTag}`;
        },
    },
    watch: {
        appDetail: {
            handler() {
                if (this.appDetail.join_community_info) {
                    this.$root.sendLog('display', 'communityBtn_display');
                }
            },
        },
    },
    mounted() {
        if (this.thePackage) {
            this.doDisplayLog();
        }
    },
    methods: {
        downloadApp() {
            if (!this.packages || !this.packages.length) {
                if (this.jumpUrl) {
                    window.location.href = this.jumpUrl;
                    return;
                }
            }
            this.openPanel();
            this.doClickLog('game');
        },
        toTieba() {
            this.$root.sendLog('click', 'communityBtn_click');
            const token = this.getToken();
            copy(token);
            this.$root.report(token).then(() => {
                TiebaNewWakeUp.init({
                    page: 'frs',
                    param: {
                        kw: this.appDetail.join_community_info?.forum_name || '',
                        fid: this.appDetail.join_community_info?.forum_id || '',
                        obj_source: 'wise',
                        locate: 'outer_game_joinsq',
                    },
                    androidShoubaiGoCenterPage: false,
                    androidDownUrl: this.appDetail.join_community_info.download_url,
                });
            });
        },
        getToken() {
            const config = {
                page: 'frs',
                param: {
                    kw: this.appDetail.join_community_info?.forum_name || '',
                    fid: this.appDetail.join_community_info?.forum_id || '',
                    extdata: {}, // 新schema打点
                    track: '', // fe打点
                    locate: 'gamecenter',
                },
            };
            return generateToken(config);
        },
        openPanel() {
            this.$emit('openPanel');
            this.$emit('passBtnTxt', this.btnText);
            this.doClickLog('unfoldPanel');
        },
        doClickLog(value) {
            let content = {
                value: value,
                ext: {
                    id: '',
                    ext: Object.assign({
                        multi: !!(this.packages && this.packages.length > 1),
                        action: this.thePackage && this.thePackage.action,
                        sourceMap: 'third',
                    }, this.$root.extData),
                    pos: '',
                },
            };
            this.$logger.click(content);
        },
        doDisplayLog() {
            this.$logger.display({
                value: 'game',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign({
                                multi: !!(this.packages && this.packages.length > 1),
                                action: this.thePackage && this.thePackage.action,
                            }, this.$root.extData),
                            pos: '',
                        },
                    ],
                },
            });
        },
    },
};

</script>

<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    *{
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color:transparent;
    }

    .center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .detail-download-wrapper{
        width: px2rem(1242);
        position: fixed;
        bottom: 0;
        height: px2rem(192);
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 -2px 5px #eee;
        .go-community {
            margin-right: 35px;
        }
        .download-btn {
            width: px2rem(1000);
            height: px2rem(132);
            line-height: px2rem(132);
            border-radius: px2rem(66);
            background-color: #38f;
            font-size: px2rem(54);
            color: #fff;
            text-align: center;
            display: flex;
            .btn-text {
                flex: 1;
                .price {
                    margin-left: px2rem(30);
                }
            }
        }
    }
</style>